import _ from 'lodash';
import Vue from 'vue';

import currencyFormatter from 'currency-formatter';

import { fromUnixTime, parse, format, getTime } from 'date-fns';
// import { zonedTimeToUtc, utcToZonedTime } from 'date-fns-tz';
// const timeZone = 'Europe/Berlin';

export const findPrice = (article, customer, defaultCustomerGroup, object = false) => {
    let price = 0;

    let type = 'main';
    if (defaultCustomerGroup.id !== _.get(customer, 'customerGroup.id')) type = 'group';

    let p;
    if (type === 'main') p = article.prices.find(el => el.type === type);
    else p = article.prices.find(el => _.get(el, 'customerGroup.id') === _.get(customer, 'customerGroup.id'));

    if (p && p.value) {
        if (object) price = p;
        else price = p.value;
    }
    return price;
};

export const timestamp2date = value => {
    return fromUnixTime(value);
};
Vue.filter('timestamp2date', timestamp2date);

export const date2timestamp = value => {
    return getTime(parse(value, 'dd.MM.yyyy', new Date())) / 1000;
};
Vue.filter('date2timestamp', date2timestamp);

export const formatDate = (value, pattern = 'dd.MM.yyyy') => {
    if (value === null) return '';
    return format(value, pattern);
};
Vue.filter('formatDate', formatDate);

export const formatTimestamp = (value, pattern = 'dd.MM.yyyy') => {
    if (value === null) return '';
    return format(timestamp2date(value), pattern);
};
Vue.filter('formatTimestamp', formatTimestamp);

export const moneyFormat = (value, code = 'EUR') => {
    return currencyFormatter.format(value, { code });
};
Vue.filter('moneyFormat', moneyFormat);
